import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Alert, Card, DescriptionList, DescriptionListItem, SimpleCardHeading} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import RequestedTime from "@widgets/pos/orders/details/order/overview/header/RequestedTime";
import OnlinePayment from "./OnlinePayment";

type Props = {
    order: PlacedOrderOverview,
};

const PaymentFulfilmentCard = ({order}: Props) => {
    const intl = useIntl();

    return (
        <Card
            header={
                <CardHeader>
                    <SimpleCardHeading title={<FormattedMessage id={"payment-and-fulfillment"}/>}/>
                </CardHeader>
            }
        >
            <DescriptionList compact={true}>
                <DescriptionListItem
                    title={intl.formatMessage({id: "fulfillment"})}
                    content={intl.formatMessage({id: order.delivery ? "delivery" : "takeaway"})}
                />

                <DescriptionListItem
                    title={intl.formatMessage({id: "requested-time"})}
                    content={<RequestedTime order={order}/>}
                />

                <DescriptionListItem
                    title={intl.formatMessage({id: "payment"})}
                    content={
                        order.paymentMethod === "ONLINE"
                            ? <OnlinePayment order={order}/>
                            : order.paidInPersonOn !== null
                                ? (
                                    <Alert
                                        type={"success"}
                                        title={<FormattedMessage id={"paidInRestaurant"}/>}
                                    />
                                )
                                : (
                                    <Alert
                                        type={"warning"}
                                        title={<FormattedMessage id={"customerPaymentMethod"}/>}
                                        content={
                                            order.delivery
                                                ? <FormattedMessage id={"customerPaysAtDoorstep"}/>
                                                : <FormattedMessage id={"customerPaysAtPickup"}/>
                                        }
                                    />
                                )
                    }
                />

                {
                    order.delivery &&
                    <DescriptionListItem
                        title={intl.formatMessage({id: "courier"})}
                        content={
                            order.courier === null
                                ? <FormattedMessage id={"noCourierLinked"}/>
                                : `${order.courier.firstName} ${order.courier.lastName}`
                        }
                    />
                }

                {
                    order.deliveryAddress !== null &&
                    <DescriptionListItem
                        title={intl.formatMessage({id: "deliveryAddress"})}
                        content={
                            <address className={"flex flex-col items-start justify-start not-italic"}>
                                {
                                    order.deliveryAddress.extraAddressInfo !== null &&
                                    <Alert
                                        containerClassname={"mb-3"}
                                        type={"warning"}
                                        title={order.deliveryAddress.extraAddressInfo}
                                    />
                                }
                                <p>
                                    <FormattedMessage
                                        id={"formattedAddressLine1"}
                                        values={{
                                            street: order.deliveryAddress.street,
                                            streetNumber: order.deliveryAddress.streetNumber,
                                        }}
                                    />
                                </p>
                                <p>
                                    <FormattedMessage
                                        id={"formattedAddressLine2"}
                                        values={{
                                            postalCodeDigits: order.deliveryAddress.postalCodeDigits,
                                            postalCodeLetters: order.deliveryAddress.postalCodeLetters,
                                            city: order.deliveryAddress.city,
                                        }}
                                    />
                                </p>
                            </address>
                        }
                    />
                }
            </DescriptionList>
        </Card>
    );
};

export default PaymentFulfilmentCard;